import { useState } from 'react'

import { Steps } from '../Steps/Steps'

export const useLaptopHelperNavigation = () => {
  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const [screenHistory, setScreenHistory] = useState([0])

  const next = () => {
    const nextPage = currentPageIndex + 1
    setCurrentPageIndex(nextPage)
    setScreenHistory([...screenHistory, nextPage])
  }

  const back = () => {
    const previousPage = screenHistory[screenHistory.length - 2]
    if (previousPage !== undefined) {
      setCurrentPageIndex(previousPage)
      setScreenHistory(screenHistory.slice(0, -1))
    }
  }

  const goToLastPage = () => {
    setCurrentPageIndex(Steps.length - 1)
    setScreenHistory([...screenHistory, Steps.length - 1])
  }

  const canGoBack = screenHistory.length > 1
  const canGoNext = currentPageIndex < Steps.length - 1
  const isLastPage = currentPageIndex === Steps.length - 1

  return {
    component: Steps[currentPageIndex].component,
    title: Steps[currentPageIndex]?.title || `Step ${currentPageIndex + 1}`,
    next,
    back,
    canGoBack,
    canGoNext,
    isLastPage,
    goToLastPage,
  }
}
